import { render, staticRenderFns } from "./_base-editor.vue?vue&type=template&id=556ee6b7&"
import script from "./_base-editor.vue?vue&type=script&lang=js&"
export * from "./_base-editor.vue?vue&type=script&lang=js&"
import style0 from "./_base-editor.vue?vue&type=style&index=0&id=556ee6b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports